/*
 * View for creating an ad-hoc (Tableau) workbook
 */

define(["marionette", "./template/adHocWorkbooksModalTemplate.html"], function (
  Marionette,
  AdHocWorkbooksModalTemplate,
) {
  var AdHocWorkbooksModalView = {};

  AdHocWorkbooksModalView.adHocWorkbooksModalView = Marionette.ItemView.extend({
    template: AdHocWorkbooksModalTemplate,
    getNameValue: function () {
      return this.$el.find("#workbookName").val();
    },
    nameError: function (errorMessage) {
      this.$el
        .find("#nameError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
  });

  return AdHocWorkbooksModalView;
});
